module.exports = __webpack_public_path__ + "img/profile-man-4-min.ce89a073.jpg";